import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=c5604b2e&"
import script from "./snackbar.component.ts?vue&type=script&lang=ts&"
export * from "./snackbar.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports